/* eslint-disable indent */
import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setHrLoading = (data) => (dispatch) => {
  dispatch({
    type: types.HrTypes.HR_SET_LOADING,
    payload: data
  });
};

// clear result
const clearHrResult = () => (dispatch) => {
  dispatch({
    type: types.HrTypes.HR_CLEAR_RESULT
  });
};

// clear error
const clearHrErrors = () => (dispatch) => {
  dispatch({
    type: types.HrTypes.HR_CLEAR_ERRORS
  });
};

// get function
const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

const addReportingManagers =
  (userData, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const addManagerSuccess = await axios.post(
        `${baseUrlNode}${api.Hr_Api.ADD_REPORTING_MANAGERS_API}`,
        userData
      );
      dispatch({
        type: types.HrTypes.ADD_REPORTING_MANAGERS,
        payload: addManagerSuccess.data
      });
    } catch (addManagerError) {
      const errorData = {
        data: addManagerError.response.data,
        status: addManagerError.response.status
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

// get all reporting managers
const getReportingMangers =
  (filterBy, loginType) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Hr_Api.GET_REPORTING_MANAGERS_API}/${filterBy}`;
    const type = types.HrTypes.GET_REPORTING_MANAGERS;
    const errorType = types.HrTypes.HR_GET_ERRORS;
    getFunction(url, type, errorType, dispatch);
  };

// get all zone
const getAllZones = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Hr_Api.GET_ZONE_API}`;
  const type = types.HrTypes.GET_ZONE;
  const errorType = types.HrTypes.HR_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const getAllMissingAttendanceList =
  (missingAttendanceGetData, loginType) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Hr_Api.ALL_MISSING_ATTENDANCE_API}/${missingAttendanceGetData}/${loginType}`;
    const type = types.HrTypes.ALL_MISSING_ATTENDANCE_LIST;
    const errorType = types.HrTypes.HR_GET_ERRORS;

    getFunction(url, type, errorType, dispatch);
  };

// ------get leave
const getALlLeaves =
  (leaveGetData, loginType) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Hr_Api.GET_ALL_LEAVE_API}/${leaveGetData}/${loginType}`;
    const type = types.HrTypes.GET_ALL_LEAVE;
    const errorType = types.HrTypes.HR_GET_ERRORS;

    getFunction(url, type, errorType, dispatch);
  };

const myAppliedLeave =
  (leaveGetData, loginType) => async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Hr_Api.MY_LEAVE_API}/${leaveGetData}/${loginType}`;
    const type = types.HrTypes.MY_APPLIED_LEAVE;
    const errorType = types.HrTypes.HR_GET_ERRORS;

    getFunction(url, type, errorType, dispatch);
  };

// get reimbursement
const getReimbursement =
  (month, year, typeId, reimbursementType, loginType, date) =>
  async (dispatch) => {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Hr_Api.GET_ALL_REIMBURSEMENT_API}/${month}/${year}/${typeId}/${reimbursementType}`;
    const type = types.HrTypes.GET_ALL_REIMBURSEMENT;
    const errorType = types.AccessTypes.REIMBURSEMENT_GET_ERRORS;
    dispatch({
      type: types.HrTypes.HR_INPUTS,
      payload: { date, typeId }
    });
    getFunction(url, type, errorType, dispatch);
  };

// get all designation
const getAllDesignation = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Hr_Api.GET_DESIGNATION_API}`;
  const type = types.HrTypes.GET_DESIGNATION;
  const errorType = types.HrTypes.HR_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// get all department
const getAllDepartment = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Hr_Api.GET_DEPARTMENT_API}`;
  const type = types.HrTypes.GET_DEPARTMENT;
  const errorType = types.HrTypes.HR_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// add leave vendor
const applyLeaveAction =
  (leaveBody, leaveId, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const applyLeaveSuccess = await axios.post(
        `${baseUrlNode}${api.Hr_Api.APPLY_LEAVE_API}/${leaveId}/${loginType}`,
        leaveBody
      );
      dispatch({
        type: types.HrTypes.APPLY_LEAVE,
        payload: applyLeaveSuccess.data
      });
    } catch (applyLeaveError) {
      const errorData = {
        data: applyLeaveError.response.data,
        status: applyLeaveError.response.status
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

// add department or designation
const addDepartmentOrDesignation =
  (constantData, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const handleReimbursementSuccess = await axios.post(
        `${baseUrlNode}${api.Hr_Api.ADD_DEPARTMENT_DESIGNATION_API}`,
        constantData
      );
      dispatch({
        type: types.HrTypes.ADD_DEPARTMENT_DESIGNATION_SUCCESS,
        payload: {
          message: handleReimbursementSuccess.data.message,
          inputData: constantData
        }
      });
    } catch (constantDataError) {
      const errorData = {
        data: constantDataError.response.data,
        status: constantDataError.response.status
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

// handle reimbursement
const handleReimbursement =
  (reimbursementDetails, loginType) => async (dispatch) => {
    try {
      const { baseUrlNode } = await helperFunction.checkLoginType(
        loginType
      );
      const handleReimbursementSuccess = await axios.post(
        `${baseUrlNode}${api.Hr_Api.HANDLE_REIMBURSEMENT}`,
        reimbursementDetails
      );
      dispatch({
        type: types.HrTypes.HANDLE_REIMBURSEMENT_SUCCESS,
        payload: handleReimbursementSuccess.data
      });
    } catch (handleReimbursementError) {
      const errorData = {
        data: handleReimbursementError.response.data,
        status: handleReimbursementError.response.status
      };
      dispatch({
        type: types.HrTypes.HR_GET_ERRORS,
        payload: errorData
      });
    }
  };

export {
  setHrLoading,
  clearHrErrors,
  clearHrResult,
  getReimbursement,
  getAllDepartment,
  getAllDesignation,
  handleReimbursement,
  addDepartmentOrDesignation,
  getALlLeaves,
  applyLeaveAction,
  myAppliedLeave,
  getAllMissingAttendanceList,
  addReportingManagers,
  getReportingMangers,
  getAllZones
};
